import { Vue, Component, Prop } from 'vue-property-decorator'
import { CreateElement } from 'vue';
import '!style-loader!css-loader!sass-loader!postcss-loader!./style.scss'

@Component
export default class extends Vue {
  blurCount = 0

  @Prop({ required: true })
  errors!: string[]

  @Prop({ default: 'top' })
  position!: string

  @Prop({ default: false })
  forceEnable!: boolean

  @Prop({ default: true })
  activateAfterBlur!: boolean

  get show() {
    return this.forceEnable || (this.activateAfterBlur ? this.blurCount > 0 : true)
  }

  render(h: CreateElement) {
    return h('div',
      {
        class: { 'validation-field': true },
        style: {
        },
        on: {
          focusout: () => {
            this.blurCount++
          },
        },
        directives: [
          {
            name: 'tooltip',
            value: {
              show: this.show && this.errors.length > 0,
              content: this.errors.join('\n'),
            },
            modifiers: {
              [this.position]: true,
            },
          },
        ],
      }, [
        this.$slots.default,
      ],
    )
  }
}
